import { z } from "zod";
import { ENROLLMENT_STATES } from "./types.js";

// ---------------------------------------------------------------------------
// Checkpoint Message Schema — validates at queue boundary
// ---------------------------------------------------------------------------

export const enrollmentCheckpointSchema = z.object({
  enrollmentId: z.string().min(1),
  tenantId: z.string().min(1),
  workflowId: z.string().min(1),
  workflowVersion: z.number().int().min(1),
  contactId: z.string().min(1),
  currentNodeId: z.string().nullable(),
  state: z.enum(ENROLLMENT_STATES),
  stepRetryCount: z.number().int().min(0),
  messagesSent: z.number().int().min(0),
  correlationId: z.string().min(1),
  triggerEventId: z.string().min(1),
  createdAt: z.number(),
  lastTransitionAt: z.number(),
  completedAt: z.number().nullable(),
  errorMessage: z.string().nullable(),
  alarmGeneration: z.number().int().min(0),
  checkpointedAt: z.number(),
});

export type EnrollmentCheckpointMessage = z.infer<typeof enrollmentCheckpointSchema>;
